// extracted by mini-css-extract-plugin
export default {"main":"AIMarkingHeaderLine_main__NDUUZ"};